import { validateEmail, validatePhoneNumber, validatePassword } from "../utils";

import { FormValidationResult } from "../utils";

export function validateRegistrationForm(
  email: string,
  phoneNumber: string,
  password: string,
  confirmPassword: string,
  passwordStrength: { score: number } | null,
): FormValidationResult {
  const emailValidation = validateEmail(email);
  if (!emailValidation.isValid) return emailValidation;

  const phoneValidation = validatePhoneNumber(phoneNumber);
  if (!phoneValidation.isValid) return phoneValidation;

  const passwordValidation = validatePassword(
    password,
    confirmPassword,
    passwordStrength,
  );
  if (!passwordValidation.isValid) return passwordValidation;

  return { isValid: true };
}

export function validateResetPasswordForm(
  password: string,
  confirmPassword: string,
  passwordStrength: { score: number } | null,
): FormValidationResult {
  const passwordValidation = validatePassword(
    password,
    confirmPassword,
    passwordStrength,
  );
  if (!passwordValidation.isValid) return passwordValidation;

  return { isValid: true };
}
